import React from 'react';
import moment from 'moment';
import { Accordion, Typography } from '@material-ui/core';
import { FlippedOrderExpansionPanelSummary, StyledCheckbox } from '../../../utils/functionsUtils';
import { headers } from './headers';
import { styleCertificate } from '../styleCertificate';

const DetailContracts = ({data, handleChangeChecked,isSelectedCheck}) => {
  const classes = styleCertificate();

  const getValueKey = (object, header) => {
      if (header.child === null) {
          if(header?.field === 'contract'){
            const contract = data?.contractTypeFormat?.contractType?.contractTypeDescription;
            return contract;
          }
          if(header?.field === 'name'){
            const name = `${data?.employee?.firstName} ${data?.employee?.secondName ?? ''} ${data?.employee?.surname} ${data?.employee?.secondSurname ?? ''}`;
            return name;
          }
          if(header.field === 'creationDate'){
            const date = moment(data?.creationDate).format('DD-MM-YYYY');
            return date;
          }
          if (header?.field) {
            let result = "";
            if (header.field.includes(",")) {
              header.field.split(/\s*,\s*/).forEach(function (myString) {
                result += object[myString] + " ";
              });
              return result;
            }
            return object[header?.field];
          }
          return "";
      }
      return object[header?.field] !== null
      ? object[header?.field][header?.child]
      : "";
  };
  
  return (
    <div style={{width: '100%', marginTop: '10px'}}>
      <Accordion style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}>
        <FlippedOrderExpansionPanelSummary
          aria-controls='panel1c-content'
          id={'id'}
        >
          <div>
            <StyledCheckbox
              color="success"
              name="checkBox" 
              value={data?.id}
              defaultChecked={null}
              checked={isSelectedCheck(data?.id)}
              className={classes.checked}
              onChange={(e) => handleChangeChecked(e)}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </div>
          {
            headers.initialHeaders.map((header) => (
              <div className={classes.column}>
                <Typography className={classes.heading}>
                  {header?.title}
                </Typography>
                <Typography className={classes.secondaryHeading} style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                  {getValueKey(data, header)}
                </Typography>
              </div>
            ))
          }
        </FlippedOrderExpansionPanelSummary>
      </Accordion>
    </div>
  )
}

export default DetailContracts